import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { isMobile } from 'react-device-detect';
import './App.css';
import PeopleCount from './components/PeopleCount'
import useStore from './store/store';
import RoomsChoice from './components/RoomsChoice';
import axios from 'axios';
import ProgramChoice from './components/ProgramChoice';
import DateChoice from './components/DateChoice';
import RightPanel from './components/RightPanel';
import PeopleCountMobile from './components/mobile/PeopleCountMobile';
import FinalPage from './components/FinalPage';
import ProgramChoiceMobile from './components/mobile/ProgramChoiceMobile';
import DateChoiceMobile from './components/mobile/DateChoiceMobile';
import FinalPageMobile from './components/mobile/FinalPageMobile';
import RoomsChoiceMobile from './components/RoomsChoiceMobile';


const App = () => {
  const { step, setRoomVariants } = useStore((state) => state);
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setIsLoading(true);
    const getRoomsData = async () => {
      const { data } = await axios.get('https://kivach.ru/calc-new/api_new.php?method=guests_rooms');
      const { guests, ...rest } = data.res;
      setRoomVariants(rest)
    }
    getRoomsData().finally(() => setIsLoading(false))
  }, [setRoomVariants])

  const _content = () => {
    switch (step) {
      case 1:
        return !isMobile ? <PeopleCount /> : <PeopleCountMobile />;
      // return <PeopleCount />;

      case 2:
        return !isMobile ? <RoomsChoice /> : <RoomsChoiceMobile />;
      // return  <RoomsChoice />;
      case 3:
        return !isMobile ? <ProgramChoice /> : <ProgramChoiceMobile />;
      // return  <ProgramChoice />;

      case 4:
        return !isMobile ? <DateChoice /> : <DateChoiceMobile />;
      // return  <DateChoice />;
      case 5:
        return !isMobile ? <FinalPage /> : <FinalPageMobile />;
      // return <FinalPage />;

      default:
        break;
    }
  }

  return (
    <div className="App">
      <div className='App__wrapper'>
        <div className="content__wrapper">
          {!isLoading ? (
            <>
              <div className={clsx(["left", step === 5 && 'full-width'])}>
                {_content()}
              </div>
              <RightPanel />
            </>) : (
              <h3 style={{ margin: '50px auto'}}>Подгружаем данные. Пожалуйста подождите.</h3>
            )}
        </div>

      </div>
    </div>
  );
}

export default App;
